import type { MessageDescriptor } from 'react-intl';
import type { MetaFunction } from 'react-router';

import { intl } from '~/i18n';

export const createMeta =
  (title: string | MessageDescriptor): MetaFunction =>
  () => {
    return [
      {
        title:
          typeof title !== 'string'
            ? //TODO other locales
              intl('en-GB').formatMessage(title)
            : title,
      },
    ];
  };
